// utils/createCrudThunks.js
import { createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from 'react-toastify';

export const createCrudThunks = (entidade, api, label) => {
  const get = createAsyncThunk(`${entidade}/get`, async () => {
    // console.log('🔧 API recebida:', api)

    try {
     // return await api.get();
      const res = await api.get();
  // console.log('🚀 Resposta da API:', res.data);
  return res.data;
    } catch (error) {
      toast.error(`Erro ao carregar ${label}`);
      throw error;
    }
  });

  const add = createAsyncThunk(`${entidade}/add`, async (data) => {
    try {
      const response = await api.add(data);
      toast.success(`${label} adicionada com sucesso`);
      return response;
    } catch (error) {
      toast.error(`Erro ao adicionar ${label}`);
      throw error;
    }
  });

  const update = createAsyncThunk(`${entidade}/update`, async (data) => {
    try {
      const response = await api.update(data);
      toast.success(`${label} alterada com sucesso`);
      return response;
    } catch (error) {
      toast.error(`Erro ao alterar ${label}`);
      throw error;
    }
  });

  const deletar = createAsyncThunk(`${entidade}/delete`, async (id) => {
    try {
      const response = await api.delete(id);
      toast.success(`${label} excluída com sucesso`);
      return response;
    } catch (error) {
      toast.error(`${label} não pode ser excluída`);
      throw error;
    }
  });

  return { get, add, update, deletar };
};
